const WOD_COMBINATIONS = {
    "DB snatch": {min: 10, max: 50, pass: 5, difficulty: 4},
    "Toes to bar": {min: 10, max: 50, pass: 5, difficulty: 8},
    "Thrusters": {min: 10, max: 50, pass: 6, difficulty: 5},
    "Overhead squat": {min: 10, max: 50, pass: 5, difficulty: 5},
    "Deadlift": {min: 5, max: 10, pass: 5, difficulty: 5},
    "Box Jumps": {min: 10, max: 50, pass: 15, difficulty: 5},
    "Pull-ups": {min: 10, max: 50, pass: 10, difficulty: 3},
    "Bench Press": {min: 10, max: 20, pass: 5, difficulty: 2},
    "100mt run": {min: 1, max: 5, pass: 1, difficulty: 4},
    "200mt run": {min: 1, max: 4, pass: 1, difficulty: 6},
    "300mt run": {min: 1, max: 3, pass: 1, difficulty: 7},
    "Knee to elbows": {min: 10, max: 40, pass: 10, difficulty: 8},
    "Burpees": {min: 5, max: 30, pass: 5, difficulty: 3},
    "Squats": {min: 20, max: 50, pass: 5, difficulty: 4},
};

export default WOD_COMBINATIONS;


// WEBPACK FOOTER //
// ./src/shared/wod-combinations.js